import * as customerActions from '../actions/customers';
import * as fetchingState from '../constants/fetchingState';
import { getErrorMessage } from '../constants/errorCode';

const initialState = {
    fetching: fetchingState.INITIAL,
    customers: [],
    updateFetching: fetchingState.INITIAL,
    updateResult: undefined,
    createFetching: fetchingState.INITIAL,
    createResult: undefined,
    resetPasswordFetching: fetchingState.INITIAL,
    error: undefined
};

export function customerReducer(state, action) {

    switch (action.type) {
        case customerActions.FETCH_CUSTOMERS: {
            return { ...state, fetching: fetchingState.FETCHING, error: undefined, pages: 0 };
        }
        case customerActions.SUCCESS_FETCH_CUSTOMERS: {
            if (!action.data.error)
                return { ...state, fetching: fetchingState.FETCHED, customers: action.data.Entities, pages: action.data.Pages, perPage: action.data.PerPage, totalAmount: action.data.TotalAmount, error: undefined };
        }
        case customerActions.FAILURE_FETCH_CUSTOMERS: {
            return { ...state, fetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) };
        }
        case customerActions.UPDATE_CUSTOMER: {
            return { ...state, updateFetching: fetchingState.FETCHING, crudError: undefined };
        }
        case customerActions.SUCCESS_UPDATE_CUSTOMER: {
            if (!action.data.error) {
                const customers = updateCustomers(action.data, state.customers);
                return { ...state, customers, updateFetching: fetchingState.FETCHED, crudError: undefined };
            }
        }
        case customerActions.FAILURE_UPDATE_CUSTOMER: {
            return { ...state, updateFetching: fetchingState.FAILED, updateResult: action.data.error, crudError: getErrorMessage(action.data.error) };
        }
        case customerActions.CLEAR_UPDATE_CUSTOMER: {
            return { ...state, updateFetching: fetchingState.INITIAL, updateResult: undefined, crudError: undefined };
        }
        case customerActions.CREATE_CUSTOMER: {
            return { ...state, createFetching: fetchingState.FETCHING, crudError: undefined };
        }
        case customerActions.SUCCESS_CREATE_CUSTOMER: {
            if (!action.data.error)
                return { ...state, createFetching: fetchingState.FETCHED, crudError: undefined };
        }
        case customerActions.FAILURE_CREATE_CUSTOMER: {
            return { ...state, createFetching: fetchingState.FAILED, createResult: action.data.error, crudError: getErrorMessage(action.data.error) };
        }
        case customerActions.CLEAR_CREATE_CUSTOMER: {
            return { ...state, createFetching: fetchingState.INITIAL, createResult: undefined, crudError: undefined };
        }
        case customerActions.SUCCESS_CUSTOMER_IS_BUSY: {
            if (action.data)
                throw action.error;
            else
                return state
        }
        case customerActions.FAILURE_CUSTOMER_IS_BUSY: {
            throw action.error;
        }
        case customerActions.CLEAR_CUSTOMERS: {
            return { ...state, customers: [] };
        }
        case customerActions.FETCH_RESET_PASSWORD: {
            return { ...state, resetPasswordFetching: fetchingState.FETCHING, error: undefined };
        }
        case customerActions.SUCCESS_RESET_PASSWORD: {
            var customers = updateCustomers(action.data, state.customers);
            return { ...state, customers, resetPasswordFetching: fetchingState.FETCHED, error: undefined };
        }
        case customerActions.FAILURE_RESET_PASSWORD: {
            return { ...state, resetPasswordFetching: fetchingState.FAILED, error: getErrorMessage(action.data.error) };
        }
        case customerActions.CLEAR_RESET_PASSWORD: {
            return { ...state, resetPasswordFetching: fetchingState.INITIAL };
        }
        case customerActions.FETCH_SEND_SMS:
            return { ...state, smsSendFetching: fetchingState.FETCHING, smsSendindErrors: undefined };
        case customerActions.SUCCESS_SEND_SMS:
            return { ...state, smsSendFetching: fetchingState.FETCHED, smsSendindErrors: undefined };
        case customerActions.FAILURE_SEND_SMS:
            return { ...state, smsSendFetching: fetchingState.FAILED, smsSendindErrors: getErrorMessage(action.data.error) };
        case customerActions.CLEAR_SEND_SMS:
            return { ...state, smsSendFetching: fetchingState.INITIAL, smsSendindErrors: undefined };
        default: return state;
    }
};

export function customerExistsReducer(state, action) {
    switch (action.type) {
        case customerActions.FETCH_CHECK_CUSTOMER:
            state = state.update('fetching', () => fetchingState.FETCHING);
            state = state.update('customerExists', () => false);
            state = state.update('customer', () => undefined);
            state = state.update('error', () => undefined);
            break;
        case customerActions.SUCCESS_FETCH_CHECK_CUSTOMER:
            state = state.update('fetching', () => fetchingState.FETCHED);
            state = state.update('customerExists', () => true);
            state = state.update('customer', () => action.data);
            state = state.update('error', () => undefined);
            break;
        case customerActions.FAILURE_FETCH_CHECK_CUSTOMER:
            state = state.update('fetching', () => fetchingState.FAILED);
            state = state.update('customerExists', () => false);
            state = state.update('customer', () => undefined);
            state = state.update('error', () => getErrorMessage(action.data.error));
            break;
        case customerActions.CLEAR:
            state = state.update('fetching', () => fetchingState.INITIAL);
            state = state.update('customerExists', () => false);
            state = state.update('customer', () => undefined);
        default:
            break;
    }
    return state;
};

const updateCustomers = (updatedCustomer, customers) => {
    customers = [...customers];
    const changedIndex = customers.findIndex(c => c.Id === updatedCustomer.Id);
    customers[changedIndex] = updatedCustomer;
    return customers;
}


// WEBPACK FOOTER //
// ./src/reducers/customerReducer.js